module.exports = __webpack_public_path__ + "7323c4aac3fb04d49c9f3513c51e7b1b.svg";